import api from './axios';
import { UserMetadataResponse } from './types';

const userMetadataApi = {
    getUserMetadata: async (businessId?: string): Promise<UserMetadataResponse> => {
        const response = await api.get('/user-metadata', {
            params: businessId ? { business_id: businessId } : undefined,
        });
        return response.data;
    },

    completeOnboardingStep3: async (businessId?: string): Promise<{ status: string; updated: boolean }> => {
        const response = await api.post('/user-metadata/onboarding/complete-step-3', undefined, {
            params: businessId ? { business_id: businessId } : undefined,
        });
        return response.data;
    },

    getAllBusinesses: async (): Promise<import('./types').AllBusinessesResponse> => {
        const response = await api.get('/user-metadata/all-businesses');
        return response.data;
    },

    updateUserMetadata: async (data: import('./types').UpdateUserMetadataRequest, businessId?: string): Promise<UserMetadataResponse> => {
        const response = await api.put('/user-metadata', data, {
            params: businessId ? { business_id: businessId } : undefined,
        });
        return response.data;
    },

    completeTutorialPage: async (
        pageKey: string,
        version: number = 1,
        businessId?: string,
    ): Promise<UserMetadataResponse> => {
        const response = await api.patch('/user-metadata/tutorial-state', {
            page_key: pageKey,
            version,
            status: 'completed',
        }, {
            params: businessId ? { business_id: businessId } : undefined,
        });
        return response.data;
    },
};

export default userMetadataApi;
